import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pay-type-with-amount d-flex flex-column"
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payTypes, (payType, key) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                    key: `payTypeWithAmount-${key}`,
                    flat: "",
                    tile: "",
                    class: _normalizeClass(`pay-type-with-amount-item d-flex ${_ctx.alignClass}`)
                }, {
                    default: _withCtx(() => [
                        (payType.orderAmount > 0)
                            ? (_openBlock(), _createBlock(_component_Chip, {
                                key: 0,
                                class: "mr-1",
                                "brg-chip-color": payType.color,
                                text: _ctx.$t(_ctx.isFullText ? payType.text : payType.shortenText)
                            }, null, 8 /* PROPS */, ["brg-chip-color", "text"]))
                            : _createCommentVNode("v-if", true),
                        _createVNode(_component_v_card_title, { class: "pay-type-with-amount-item__amount body2-text text-black pa-0" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.amount(payType)), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
    }));
}
